/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import { string } from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import BeaconDisclosureModal from 'components/shared/DisclosureModal/DisclosureModal';
import infoHelpIcon from 'assets/icons/info-help-icon-filled.svg';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import { getBrokerageAccountsFromSweepMap } from 'state/account/AccountSelectors';

const AccountNumber = ({ accountWChecksum }) => (
  <Fragment>{accountWChecksum}</Fragment>
);
const AccountNumberWithPermissions = WithUserPermissions(AccountNumber);

const SweepModalV2 = ({
  accountId,
  accountWChecksum,
  sweepAccountsMap,
  title
}) => {
  const sweepAccount = sweepAccountsMap[accountId];
  const accountWChecksumOption = sweepAccount
    ? `${sweepAccount.accountNumber}-${sweepAccount.accountChecksum}`
    : accountWChecksum;

  return (
    <BeaconDisclosureModal
      linkContent={title}
      closeOnClickOut={true}
      icon={<svg slot="suffix" viewBox="3.5 3.5 17 17"><image href={infoHelpIcon}></image></svg>}
      size={'normal'}
      sweep={true}>
      <div className="b-typography-serif--headline--200">Sweep Accounts</div>
      <div className="b-typography-sans-serif--body--200 b-font-weight-light">
        <p>
          This Money Market fund is linked to your Brokerage Account #
          <AccountNumberWithPermissions
            accountWChecksum={accountWChecksumOption}
            shouldMask
          />
          .
        </p>
        <p>
          Securities transactions and/or cash distributions from positions held
          in that specific brokerage account will settle in or out of this
          &quot;sweep&quot; account.
        </p>
      </div>
    </BeaconDisclosureModal>
  );
};

SweepModalV2.propTypes = {
  accountWChecksum: string,
  className: string,
  content: string
};

SweepModalV2.defaultProps = {
  title: 'Sweep'
};

const mapStateToProps = (state) => ({
  sweepAccountsMap: getBrokerageAccountsFromSweepMap(state)
});

export default connect(mapStateToProps)(SweepModalV2);
